export const thousandSeparator = Intl.NumberFormat('es-ES')
  .format(11111)
  .replace(/\p{Number}/gu, '');

export const decimalSeparator = Intl.NumberFormat('es-ES')
  .format(1.1)
  .replace(/\p{Number}/gu, '');
